
import { computed, defineComponent, PropType } from 'vue'
import { LoaderColorsArray, LoaderColorsEnum, LoaderColorsMap, LoaderTypeEnum, LoaderTypeMap, LoaderTypesArray } from './BLoader.types'

export default defineComponent({
  name: 'BLoader',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: null,
    },
    color: {
      type: String as PropType<LoaderColorsEnum>,
      required: false,
      default: LoaderColorsEnum.PRIMARY,
      validator: (prop: LoaderColorsEnum) => LoaderColorsArray.includes(prop)
    },
    type: {
      type: String as PropType<LoaderTypeEnum>,
      required: false,
      default: LoaderTypeEnum.BOUNCE,
      validator: (prop: LoaderTypeEnum) => LoaderTypesArray.includes(prop),
    }
  },
  setup(props) {
    const classes = computed(() => LoaderColorsMap[props.color])

    const typeClasses = computed(() => LoaderTypeMap[props.type])
    const finalClasses = computed(() => `${typeClasses.value} ${classes.value}`)

    return {
      finalClasses,
      LoaderTypeEnum,
    }
  },
})
